module.exports = __webpack_public_path__ + "img/Character_Shikanoin_Heizou_Thumb.be15fefc.png";